// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"6b7bae4f","943":"4a675b80"}[chunkId] + ".chunk.js";
};